package com.exura.features.plandefinition.domain.builder.plan

import com.exura.features.plandefinition.domain.model.plan.BasePlan
import com.exura.features.plandefinition.domain.model.plan.PreparationPlan
import com.exura.features.plandefinition.domain.model.plan.TreatmentPlan

/**
 * Enhanced factory for creating new plan builders
 */
object PlanBuildersNew {

    /**
     * Creates a builder for a preparation plan
     */
    fun preparationPlan() = PreparationPlanBuilderNew()

    /**
     * Creates a builder for a treatment plan
     */
    fun treatmentPlan() = TreatmentPlanBuilderNew()

    /**
     * Creates a builder from existing plan data using toBuilder pattern
     */
    fun fromPlan(plan: BasePlan): BasePlanBuilderNew<out BasePlan> {
        return when (plan) {
            is PreparationPlan -> plan.toBuilder()
            is TreatmentPlan -> plan.toBuilder()
            else -> throw IllegalArgumentException("Unknown plan type: ${plan::class.simpleName}")
        }
    }
}
